<template lang="pug">
#modal-excluir-item-exportacao
    el-dialog(
        :visible.sync='mostrarDialog',
        :close-on-click-modal='false',
        :destroy-on-close='true',
        :show-close='false',
        custom-class='no-box-shadow',
        width='600px'
    )
        section.template(slot='title')
            .modal-excluir-item-exportacao__header
                .modal-excluir-item-exportacao__header--icon
                    i.el-icon-warning-outline
                .modal-excluir-item-exportacao__header--title
                    | Aviso
        section.modal-excluir-item-exportacao__body
            .modal-excluir-item-exportacao__body--descricao
                div(v-html='identificarLabelModal()')
                br
                b {{ $t('mensagens.preAnaliseCredito.desejaContinuar') }}
        section.dialog-footer.modal-excluir-item-exportacao__action(slot='footer')
            BaseButton(size='default', @click='cancelar')
                | {{ $t('mensagens.comuns.cancelar') }}
            BaseButton(type='primary', size='default', @click='remover')
                | {{ $t('mensagens.comuns.remover') }}
</template>

<script>
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
export default {
    name: 'BaseModalExcluirItemExportacao',

    components: {
        BaseButton
    },

    props: {
        operacao: {
            type: String,
            default: 'removerItem'
        },
        nome: {
            type: String,
            required: true
        },
        documento: {
            type: String,
            required: true
        },
        mostrarDialog: {
            type: Boolean,
            default: false,
            required: true
        }
    },

    data() {
        return {};
    },

    methods: {
        identificarLabelModal() {
            if (this.operacao === 'removerItem') {
                return `<span>${this.$t('mensagens.preAnaliseCredito.voceEstaPrestesRemoverSelecaoExportacao')}:<br><br>
                ${this.documento}<br>
                ${this.nome}<br>
                </span>`;
            } else {
                return `<span>${this.$t('mensagens.preAnaliseCredito.voceEstaPrestesCancelarListaExportacao')}.<br></span>`;
            }
        },
        fecharModal() {
            this.$emit('fechar-modal');
        },
        cancelar() {
            this.$emit('cancelar');
        },
        remover() {
            this.$emit('remover');
        }
    }
};
</script>

<style lang='scss'>
#modal-excluir-item-exportacao {
    display: flex;
    box-shadow: 0 0 0px rgba(0, 0, 0) !important;
    background-color: #FFFFFF;

    .modal-excluir-item-exportacao__header {
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .modal-excluir-item-exportacao__header--icon {
            margin-right: 10px;
            font-size: 20px;
            color: #fec556;
        }

        .modal-excluir-item-exportacao__header--title {
            font-size: 20px;
            font-weight: 600;
        }
    }

    .el-dialog__header {
        background-color: #e9e9e9;
    }

    .modal-excluir-item-exportacao__body {
        width: 100%;

        .modal-excluir-item-exportacao__body--descricao {
            font-weight: 500;
            font-size: 14px;
            word-break: break-word;
        }
    }

    .modal-excluir-item-exportacao__action {
        height: 50px;
        border-top: solid 2px #e7e7e7;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        margin-top: 10px;
    }

    .el-dialog {
        background: none !important;
    }

    .el-dialog__body {
        padding: 20px;
        background-color: #FFFFFF;
        padding-bottom: 0;
    }

    .el-dialog__footer {
        background-color: #FFFFFF;
    }

    .el-form-item__label {
        padding: 0 !important;
        margin-top: 5px !important;
    }

    .el-button--primary {
        background-color: var(--primary);
        border-color: var(--primary);
        color: var(--white);
    }

    .el-button--primary:hover,
    .el-button--primary:focus {
        background-color: var(--secondary);
        border-color: var(--secondary);
        color: var(--color-button-hover);
        outline: 0px auto var(--secondary);
    }
}

.el-dialog.no-box-shadow {
    max-height: 450px !important;
}

.el-dialog.no-box-shadow .el-dialog__wrapper {
  box-shadow: none !important;
  height: auto !important;
}
</style>
